<template>
    <div>
        <div v-if="loading" class="text-center p-5"><b-spinner variant="info" /></div>
        <b-alert v-else-if="loadError" show variant="danger">
            {{ $t('label.productCategoryLoadError') }}
            <b-button size="sm" variant="outline-danger" @click="loadCategory">{{ $t('label.retryPermissionDefinitions') }}</b-button>
        </b-alert>
        <form v-else @submit.prevent="submitForm">
            <b-form-group :label="$t('label.name')">
                <b-form-input v-model.trim="form.name" required />
            </b-form-group>
            <b-form-group :label="$t('label.description')">
                <b-form-textarea v-model.trim="form.description" rows="4" />
            </b-form-group>
            <b-form-checkbox v-model="form.isActive" switch>{{ $t('label.active') }}</b-form-checkbox>
            <hr>
            <div class="d-flex justify-content-end">
                <b-button type="button" variant="danger" class="mr-2" @click="$emit('done')">{{ $t('label.cancel') }}</b-button>
                <b-button type="submit" variant="info" :disabled="!status.save">
                    <span v-if="status.save">{{ $t(categoryUUID ? 'label.updateX' : 'label.createX', [$t('module.productCategory')]) }}</span>
                    <b-spinner v-else small />
                </b-button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { productCategoryMethods } from '@/state/api';

export default {
    name: 'ProductCategoryForm',
    props: { categoryUUID: { type: String, default: '' }, searchCriteria: { type: Object, required: true } },
    data() {
        return { loading: Boolean(this.categoryUUID), loadError: false, form: { uuid: '', name: '', description: '', isActive: true } };
    },
    computed: { ...mapState('api/productCategory', ['status', 'details']) },
    created() { if (this.categoryUUID) this.loadCategory(); },
    methods: {
        ...productCategoryMethods,
        async loadCategory() {
            this.loading = true; this.loadError = false;
            try {
                const result = await this.getProductCategory({ uuid: this.categoryUUID });
                if (!result?.success) { this.loadError = true; return; }
                this.form = { ...this.details };
            } catch (error) { this.loadError = true; }
            finally { this.loading = false; }
        },
        async submitForm() {
            if (!this.status.save || !this.form.name.trim()) return;
            const action = this.categoryUUID ? this.updateProductCategory : this.createProductCategory;
            const result = await action({ data: { ...this.form, name: this.form.name.trim() }, filter: this.searchCriteria });
            if (result?.success) this.$emit('done');
        },
    },
};
</script>
